import { API_ENDPOINT } from "@cede/utils";
import { useApi } from "@/hooks/core/useApi";
import { useHubUser } from "@/hooks/user/useHubUser";
import { invalidateHubDefiAddress } from "@/hooks/user/useValidateHubDefiAddress";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { enqueueSnackbar } from "notistack";

type PerpsPnlOptInParams = {
  campaignName: string;
  exchangeAccountId: string;
};

export function usePerpsPnlOptIn() {
  const api = useApi();
  const { auth } = useHubUser();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ campaignName, exchangeAccountId }: PerpsPnlOptInParams) => {
      await api.postAuth(auth, API_ENDPOINT.HUB_TRADE_PERPS_PNL_OPT_IN, {
        bodyParams: {
          campaignName,
          exchangeAccountId,
        },
      });
      // Wait for the validate-defi-address refetch so the mutation stays "pending"
      // (button shows "Opting in...") until the access state is actually fresh.
      await invalidateHubDefiAddress(queryClient);
    },
    onError: (error: Error) => {
      enqueueSnackbar(error.message || "Failed to opt in. Please close open positions and try again.", {
        variant: "error",
      });
    },
  });
}
